<div class="container" id="spinerLoader" *ngIf="loader">
    <div class="loader">Loading...</div>
</div>

<div class="modal" id="addContactPerson">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <div class="modal-header">
                <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close"
                    (click)="closeContactModel()" (click)="resetForm(addContactPerson)"><i
                        class="fa fa-close"></i></button>
                <h4 class="modal-title">Add Contact</h4>
            </div>
            <form name="addContactPersonForm" #addContactPerson="ngForm">
                <div class="modal-body add-edit-view">
                    <div class="member-card">
                        <div class="d-flex justify-content-between">
                            <h4 class="filter-options">Personal Details</h4>
                            <div class="form-check" *ngIf="isShowTemContactButton==true" (click)="clearContactData()">
                                <input type="checkbox" class="form-check-input mr-2" id="exampleCheck1"
                                    [(ngModel)]="contact.isTemporary" name="tempContact">
                                <label class="form-check-label" for="exampleCheck1">Temporary

                                    Contact</label>
                            </div>
                        </div>
                        <hr class="hr-class mt-0" />
                        <div class="row">
                            <div class="form-group col-md-4"
                                *ngIf="user.role !='Customer Coordinator' && user.role !='Customer Admin'">
                                <Label>Select Member</Label><i class="fa fa-spin fa-spinner text-color ml-2"
                                    style="font-size: 18px;" *ngIf="selectMemberLoader"></i>

                                <ngx-select-dropdown tabindex="0" [multiple]="false" name="exitedMember" id="selectMember"
                                    [disabled]="contact.isTemporary" (change)="selectMember($event)"
                                    [config]="config" [options]="memberList" (click)="clickDropDown('selectMember')">
                                </ngx-select-dropdown>

                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-6">
                                <label>First Name</label><span class="text-danger"> * </span>
                                <input type="text" id="acontact_addFirstName" placeholder="First Name"
                                    class="form-control" #firstName="ngModel" name="firstName" maxlength="100"
                                    [(ngModel)]="contact.firstName" autocomplete="off"
                                    [ngClass]="{ 'is-invalid': addContactPerson.submitted && firstName.invalid }"
                                    required>

                                <div *ngIf="addContactPerson.submitted && firstName.invalid" class="invalid-feedback">
                                    <div *ngIf="firstName.errors.required"><span style="color: red;">First Name is
                                            required.</span></div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label>MI</label>
                                <input type="text" id="acontact_addMiddleName" placeholder="MI" name="mName"
                                    [(ngModel)]="contact.middleName" #middleName="ngModel" class="form-control"
                                    maxlength="100" autocomplete="off">

                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-md-6">

                                <label>Last Name</label><span class="text-danger"> * </span>
                                <input type="text" id="acontact_addLastName" placeholder="Last Name" name="lastName"
                                    name="lName" [(ngModel)]="contact.lastName" #lastName="ngModel" class="form-control"
                                    autocomplete="off"
                                    [ngClass]="{ 'is-invalid': addContactPerson.submitted && lastName.invalid }"
                                    maxlength="100" required>

                                <div *ngIf="addContactPerson.submitted && lastName.invalid" class="invalid-feedback">
                                    <div *ngIf="lastName.errors.required"><span style="color: red;">Last Name is
                                            required.</span></div>

                                </div>

                            </div>
                            <div class="col-md-6">

                                <label>Email ID</label>
                                <input type="email" id="addContactemail" class="form-control" placeholder="Email"
                                    maxlength="50" [(ngModel)]="contact.emailId" name="emailId" maxlength="76"
                                    autocomplete="off">



                            </div>
                        </div>

                        <div class="row form-group">

                            <div class="col-md-6">
                                <label>Moblie Number</label><span class="text-danger"> * </span>
                                <input type="text" name="workNumber" id="AddContactwork_contact_no"
                                    [ngModel]="contact.cellNumber | phoneNumberPipe"
                                    (ngModelChange)="contact.cellNumber=$event" maxlength="14" minlength="14"
                                    #workNumber="ngModel" class="form-control" placeholder="(xxx)-xxx xxxx"
                                    pattern="\(?\d+\)?[-.\s]?\d+[-.\s]?\d+"
                                    [ngClass]="{ 'is-invalid': addContactPerson.submitted && workNumber.invalid }"
                                    required>
                                <div *ngIf="addContactPerson.submitted && workNumber.invalid" class="invalid-feedback">
                                    <div *ngIf="workNumber.errors.required"><span style="color: red;">Phone Number
                                            is required.</span></div>
                                    <div *ngIf="workNumber.errors.minlength"><span style="color: red;">Phone must
                                            have 10 digits.</span></div>
                                    <div *ngIf="workNumber.errors.pattern"><span style="color: red;">Phone Number
                                            not valid.</span></div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="member-card">
                        <h4 class="filter-options">Address Details</h4>
                        <hr class="hr-class" />
                        <div class="row form-group">
                            <div class="col-md-6">
                                <label>Search Address</label>
                                <input type="text" #pick id="autocompleteAddress" class="form-control autocomplete-addr"
                                    [(ngModel)]="searchAddr" name="searchAddr" (ngModelChange)="autoSearchAddress()"
                                    placeholder="Search">
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-6">
                                <div class="form-group mb-0">
                                    <label>Address Type</label><span class="text-danger"> * </span>
                                    <select name="addressType" #addressType="ngModel" class="form-control"
                                        [(ngModel)]="contact.address.addressLocationType"
                                        [ngClass]="{ 'is-invalid': addContactPerson.submitted && addressType.invalid }"
                                        required>
                                        <option [value]="null" selected disabled>Select Address Type</option>
                                        <option *ngFor="let item of AddressType" [value]="item" name="addr_type">
                                            {{item}}
                                        </option>
                                    </select>
                                    <div *ngIf="addContactPerson.submitted && addressType.invalid"
                                        class="invalid-feedback">
                                        <div *ngIf="addressType.errors.required"><span style="color: red;">Address Type
                                                is
                                                required.</span></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Address</label><span class="text-danger"> * </span>
                                    <div class="radio my-0">
                                        <label>
                                            <input type="radio" name="pvtOrPublic" #pvtOrPublic="ngModel"
                                                [(ngModel)]="contact.address.isGlobal" [value]="false"
                                                required />Private</label>
                                        <label class="ml-4"><input type="radio" name="pvtOrPublic"
                                                #pvtOrPublic="ngModel" [(ngModel)]="contact.address.isGlobal"
                                                [value]="true" required />Public</label>
                                        <div *ngIf="addContactPerson.submitted && pvtOrPublic.invalid"
                                            class="invalid-feedback">
                                            <div *ngIf="pvtOrPublic.errors.required"><span style="color: red;">Field is
                                                    required.</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-6">
                                <label>Street Address</label>
                                <input type="text" name="streetAddress" id="aContact_StreetAddress"
                                    #streetAddress="ngModel" maxlength="75" [(ngModel)]="contact.address.streetAddress"
                                    maxlength="150" placeholder="Street Address" class="form-control" />
                            </div>
                            <div class="col-md-6">
                                <label>Zipcode</label>
                                <input type="text" id="acZipCode" placeholder="Zipcode" name="Zipcode"
                                    #zipCode="ngModel" [(ngModel)]="contact.address.zipcode" class="form-control"
                                    maxlength="5" minlength="3" pattern="[A-Za-z0-9]+" />
                                <div *ngIf="addContactPerson.submitted && zipCode.invalid" class="invalid-feedback">
                                    <div *ngIf="zipCode.errors.pattern">
                                        <span style="color: red;">ZipCode not valid.</span>
                                    </div>
                                    <div *ngIf="zipCode.errors.minlength">
                                        <span style="color: red;">ZipCode must have 3 or 5 digits.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-6">
                                <label>State</label>
                                <select name="state" class="form-control" [(ngModel)]="contact.address.stateId"
                                    (change)="getCityByState(contact.address.stateId)">
                                    <option value="" selected disabled>Select State</option>
                                    <option *ngFor="let item of stateList" [value]="item.stateId" name="state">
                                        {{item?.stateName}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-6">
                                <label>City</label>
                                <button type="button" id="addLocationPopUp" (click)="isShowAddCity=true"
                                    class="plus-icon" *ngIf="isCityButtonShow && !isShowAddCity" title="Add City">
                                    <i class="fa fa-plus-circle "></i>
                                </button>
                                <button type="button" class="plus-icon" title="Cancle Add City" *ngIf="isShowAddCity"
                                    (click)="isShowAddCity=!isShowAddCity;cityAdd.cityName=''">
                                    <i class="fa fa-times-circle"></i>
                                </button>
                                <div *ngIf="isShowAddCity">
                                    <form name="cityform" #cityform="ngForm">
                                        <div class="col-md-8 px-0"><input type="text" class="form-control"
                                                placeholder="Enter City Name" name="city" #city="ngModel"
                                                [(ngModel)]="cityAdd.cityName"
                                                [ngClass]="{ 'is-invalid': cityform.submitted && city.invalid }"
                                                required>
                                            <div *ngIf="cityform.submitted && city.invalid" class="invalid-feedback">
                                                <div *ngIf="city.errors.required"><span style="color: red;">Enter City
                                                        name.</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 pr-0">
                                            <button
                                                class="flat-butt flat-info-butt flat-info-grad-butt btn-size save-btn col-md-12"
                                                type="submit" (click)="addCity()"> Save </button>
                                        </div>
                                    </form>
                                </div>
                                <select name="city" class="form-control" [(ngModel)]="contact.address.cityId"
                                    #cityName="ngModel" *ngIf="!isShowAddCity">
                                    <option value="" selected disabled>Select City</option>
                                    <option *ngFor="let item of cityList" [value]="item.cityId">{{item?.cityName}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">

                    <button type="button" class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
                        data-dismiss="modal" (click)="closeContactModel()"
                        (click)="resetForm(addContactPerson)">Cancel</button>

                    <button type="submit" class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                    [disabled]="isSaveBtnDisabled" [ngClass]="{'cursorDisabled': isSaveBtnDisabled}"
                        (click)="saveContact(contact,addContactPerson)">Save
                        Changes</button>
                </div>
            </form>
        </div>
    </div>
</div>
